// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { MansionKind } from "../../../../define/MansionKind";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import { getOnePeopleById } from "../../../config/WeChatPeopleConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
const {ccclass, property} = cc._decorator;

const c_list = [

];
@ccclass
export default class SuperPowerSelect2 extends BasePopUpLayer {
   
    @property(cc.Node)
    nodeItem: cc.Node = null;

    @property(cc.Node)
    nodeSelect: cc.Node = null;

    private csvInfos: any = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.nodeItem.active = false;
        this.initLayer();
    }

    initLayer() {

        let csvInfos = this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.WIFE);
        if (!csvInfos) {
            console.error(`未找到表格 WIFE`);
            return;
        }
        this.refreshList();
    }

    refreshList() {
        let title = this.csvInfos.title;

        this.nodeSelect.removeAllChildren();
        let wifeData = UserDataManage.instance.mansionDataManage.wifeDataManage.wifeData;
        for (let i in this.csvInfos) {

            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            
            let infos = this.csvInfos[i];
            let item = cc.instantiate(this.nodeItem);
            this.nodeSelect.addChild(item);
            item.active = true;
           
            let nodeNoYet = item.getChildByName('nodeNoYet');
            let nodeYet = item.getChildByName('nodeYet');
            let sprHead = item.getChildByName('sprHead').getComponent(cc.Sprite);

            let name = infos[title.name];
            this.showHead(sprHead, name);

            if (wifeData.isOwnWife(i, MansionKind.WifeState.WIFE)) {
                nodeYet.active = true;
                nodeNoYet.active = false;

                let labelName = nodeYet.getChildByName('labelName')?.getComponent(cc.Label);
                if (labelName) {
                    labelName.string = name;
                }
            } else {
                nodeYet.active = false;
                nodeNoYet.active = true;

                let nodeSelect = nodeNoYet.getChildByName('nodeSelect')?.getComponent(cc.Button);
                nodeSelect.clickEvents[0].customEventData = '' + i;
                let labelName = nodeNoYet.getChildByName('nodeName')?.getChildByName('labelName')?.getComponent(cc.Label);
                if (labelName) {
                    labelName.string = name;
                }
            }
        }
    }

    async showHead(sprHead: cc.Sprite, name: string) {
        let people = getOnePeopleById(name);
        let headUrl = people.headUrl;
        sprHead.node.active = false;
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.WeChatGameBundle, false);
        bundle.load(headUrl, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    sprHead.spriteFrame = imgs;
                    sprHead.node.active = true;
                }
            }
        );
    }

    onClickConfirm(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
        this._carryData.parent.showEndUI('我立马给你安排，我们下次再见');

        let title = this.csvInfos.title;
        let info = this.csvInfos[data];
        if (!info) {
            console.error(`未找到表格数据 id = ` + data);
            return;
        }

        let event_id = info && info[title.event_id];
        if (utilsModel.isValidNumberValue(event_id)) {
            NormalGameManager._instance.addDelayTimeEvent(event_id, 1);
        }
    }

    
    // update (dt) {}
}
